import "../../font.css.ts.vanilla.mjs";
import "./baseConfig/global.css.ts.vanilla.mjs";
import "./input.css.ts.vanilla.mjs";
var r = "p273__input-a9bb_dbb8d2a__1wurg2f1", p = "p273__input-a9bb_dbb8d2a__1wurg2f2", t = "p273__input-a9bb_dbb8d2a__1wurg2f0", u = "p273__input-a9bb_dbb8d2a__1wurg2f4", e = "p273__input-a9bb_dbb8d2a__1wurg2f3";
export {
  r as darkTheme,
  p as inputStyle,
  t as lightTheme,
  u as measureInputDarkStyle,
  e as measureInputLightStyle
};
//# sourceMappingURL=input.mjs.map
